export default __webpack_public_path__ + "static/media/send_icon.5b6175a6.svg";